import React from 'react';
import Ionicon from "react-ionicons";

class ThanksModal extends React.Component {

    renderThankYou ( message, onClose ) {
        return (
            <div>
                <h3 className="h3">Thank you</h3>
                <p className="p-tag">{ message }</p>
                <ul className="buttons-left">
                    <li>
                        <button type="button" className="theme-button" onClick={ ( e ) => onClose( e ) }>
                            <span className="label">Close</span>
                        </button>
                    </li>
                </ul>
            </div>
        )
    }


    render () {

        const { isOpen, onClose, message } = this.props;

        if (isOpen === false)
            return null;

        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <button className="close-popup" type="button" onClick={ ( e ) => onClose( e ) }><Ionicon icon="ion-close"/></button>
	                    { this.renderThankYou( message, onClose) }
                    </div>
                </div>
            </div>
        )
    }
}

export default ThanksModal;



// WEBPACK FOOTER //
// src/client/components/common/elements/ThanksModal.js